import Sniffer from 'snifferjs';

// store
import { app } from '../utils/store';

import Scroll from '../modules/scroll/scroll';
import Header from '../modules/header/header';
import Animations from '../modules/animations/animations';
import Search from '../modules/search/search';
import Minicart from '../modules/minicart/minicart';
import Carousel from '../modules/carousel/carousel';
import CleanBottleTabs from '../modules/clean-bottle-tabs/clean-bottle-tabs';
import Maps from '../modules/maps/maps';
// import Video from '../modules/video/video';
// import Gallery from '../modules/gallery/gallery';
import Filters from '../modules/filters/filters';
import Footer from '../modules/footer/footer';
import Forms from '../modules/forms/forms';

export default class Components {
    constructor() {
        this.banner = document.querySelector('.banner-emotional'),
        this.header = document.querySelector('header');
        this.menu = document.getElementById('main-menu');
        this.footer = document.querySelector('footer');
        this.form = document.querySelector('form');
        this.search = document.getElementById('search-toggler');
        this.video = document.querySelector('video');
        this.gallery = document.getElementById('gallery');
        this.carousel = document.querySelector('.carousel');
        this.cart = document.querySelector('button#cart');
        this.map = document.getElementById('map');
        this.filters = document.getElementById('filters-archive');

        this.section = {
            tabs: document.querySelector('section.clean-tabs-specs'), 
            bottle: document.querySelector('section.bottle-specs'), 
        }

        this.page = {
            test: document.querySelector('.page-test'),
        }

        this.post = {
            test: document.querySelector('.page-test-article'),
        }

        this.body = document.querySelector('html');
        this.top_header = document.querySelector('.header .top-header');
        this.navbar = document.querySelector('.header .navbar')

        this.body.style.setProperty('--top-header-height', `${this.top_header.offsetHeight}px`)
        this.body.style.setProperty('--navbar-height', `${this.navbar.offsetHeight}px`)
    }

    init(){
        // app.scroll = new Scroll();
        // app.scroll.init();

        // Progressive Loading Image (Need 'data-src' or 'data-background' attribute in your HTML)
        // app.scroll.progressiveimgs();

        if(this.header){
            this.header = new Header();
            this.header.init();
        }

        if(this.banner){
            this.banner = new Animations();
            this.banner.init();
        }

        if(this.footer){
            this.footer = new Footer();
            this.footer.init();
        }

        if(this.search){
            this.search = new Search();
            this.search.init();
        }
        
        if(this.cart){
            this.cart = new Minicart();
            this.cart.init();
        }

        if(this.carousel){
            this.carousel = new Carousel();
            this.carousel.init();
        }

        if(this.filters){
            this.filters = new Filters();
            this.filters.init();
        }
        

        if(this.form){
            this.form = new Forms();
            this.form.init();
        }

        // if(this.video){
        //     this.video = new Video();
        //     this.video.init();
        // }

        // if(this.gallery){
        //     this.gallery = new Gallery();
        //     this.gallery.init();
        // }

        if(this.map){
            this.map = new Maps();
            this.map.init();
        }

        if(this.section.tabs && this.section.tabs.nextElementSibling.id == this.section.bottle.id){
            this.clean_tabs = new CleanBottleTabs();
            this.clean_tabs.init();
        }
    }

    destroy = () => {
        console.log('Destroy Components')
        // Destroy Components using JS
    }
}
